import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Collapse } from 'antd';
import api from 'api';
import { IPendingInviteUsers, IRestrictedUser } from 'interfaces';
import { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { fetchGlobalUsers } from 'store/reducers/usersGroupCreator';
import CommonRooms from './CommonRooms';
import ContactsInfo from './ContactsInfo';
import classes from './ContactsTab.module.scss';
import InviteRooms from './InviteRooms';

type Props = {
  selectedContact: IRestrictedUser;
  setSelectedContact: Dispatch<SetStateAction<IRestrictedUser | null>>;
  clearRedux: () => void;
};

export default function ContactsDetails({ selectedContact, setSelectedContact, clearRedux }: Props) {
  const { available_rooms } = useAppSelector((state) => state.userData);
  const [initialInvites, setInitialInvites] = useState<IPendingInviteUsers[]>([]);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const onCloseClick = () => {
    setSelectedContact(null);
  };

  useEffect(() => {
    dispatch(fetchGlobalUsers());
    return () => setSelectedContact(null);
  }, []);

  useEffect(() => {
    fetchInvites().then((invites) => setInitialInvites(invites));
  }, [selectedContact]);

  const fetchInvites = async () => {
    try {
      const response = await api.getInvitesByUser(selectedContact.id);
      return response.data as IPendingInviteUsers[];
    } catch (err) {
      return [];
    }
  };
  
  const isForInviteRooms = useMemo(() => {
    const filteredRooms = available_rooms.filter(
      (room) => !selectedContact.common_rooms.some(({ id }) => id === room.id)
    )!;

    return filteredRooms.filter(
      ({ is_admin, invite_id, id }) =>
        // permissions?.can_invite_users && // этого поля больше нет в комнатах
        is_admin && // замена permissions?.can_invite_users
        !invite_id &&
        !initialInvites.find(({ room, invite_status }) => room.id === id && invite_status === 1)
    );
  }, [available_rooms, selectedContact, initialInvites]);  

  const collapseItems = [
    {
      key: 'information',
      label: t('Users.HelperMenu.personalInfo'),
      children: selectedContact ? <ContactsInfo t={t} selectedUser={selectedContact} /> : null,
    },
    {
      key: 'commonRooms',
      label: t('Users.HelperMenu.commonRooms'),
      children: selectedContact ? (
        <CommonRooms t={t} clearRedux={clearRedux} rooms={selectedContact.common_rooms} />
      ) : null,
    },
  ];

  isForInviteRooms.length &&
    collapseItems.push({
      key: 'inviteRooms',
      label: t('Users.HelperMenu.inviteRooms'),
      children: (
        <InviteRooms initialInvites={initialInvites} selectedUser={selectedContact} t={t} rooms={isForInviteRooms} />
      ),
    });

  return (
    <div>
      <Button
        className={classes.backButton}
        onClick={onCloseClick}
        icon={<ArrowLeftOutlined style={{ fontSize: 18, color: 'grey' }} />}
      />
      <span className={classes.username}>
        {selectedContact.first_name} {selectedContact.last_name}
      </span>

      <Collapse
        defaultActiveKey={'information'}
        accordion
        className={classes.accordion}
        items={collapseItems}
      />
    </div>
  );
}
